module.exports = __webpack_public_path__ + "static/img/img1.33d7e325.png";